export default __webpack_public_path__ + "static/media/photo12.d1a504d2.jpg";